import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { IAsset } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { AssetService } from "../../../../shared/services/assets/asset.service";

@Component({
  selector: "app-asset-view",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    ProgressSpinnerModule,
  ],
  templateUrl: "./asset-view.component.html",
  styleUrls: ["./asset-view.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AssetViewComponent implements OnInit {
  object: IAsset | null = null; // Store the selected conduit details
  isLoading = false;

  constructor(private route: ActivatedRoute, private service: AssetService) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.load(id);
    }
  }

  load(id: string): void {
    this.service
      .get(id)
      .then((response) => {
        this.object = response?.data ?? null; // Handle null or undefined data
        this.isLoading = false;
      })
      .catch((error) => {
        console.error("Error fetching subscription details:", error);
        this.isLoading = false;
      });
  }
}
